import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Blog from "./views/blog/Blog"
import Apartment from "./views/games/Apartment"
import Contact from "./views/Contact"
import CovidInfo from "./views/about/CovidInfo"
import Gallery from "./views/games/Gallery"
import Morgue from "@/views/games/Morgue";
import Landing from "./views/Landing.vue"
import NotFound from "./views/NotFound"
import FAQ from "./views/about/FAQ"
import Pricing from "@/views/about/Pricing";
import BookNow from "@/views/booking/BookNow";


//Blog posts
import CoronaUpdate from "./views/blog/posts/CoronaUpdate"
import DemolitionDelayed from './views/blog/posts/DemolitionDelayed'
import OtcClosing from "./views/blog/posts/OtcClosing"
import OtcReopening from "./views/blog/posts/OtcReopening"

Vue.use(Router);

export default new Router({
    mode: 'history',
    linkExactActiveClass: "active",
    routes: [
        {
            path: "/",
            name: "landing",
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            }
        },
        {
            path: "/landing",
            name: "landing",
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            }
        },
        {
            path: "/pricing",
            name: "pricing",
            components: {
                header: AppHeader,
                default: Pricing,
                footer: AppFooter
            }
        },
        {
            path: "/book",
            name: "book",
            components: {
                header: AppHeader,
                default: BookNow,
                footer: AppFooter
            }
        },
        {
            path: "/blog",
            name: "blog",
            components: {
                header: AppHeader,
                default: Blog,
                footer: AppFooter
            }
        },
        {
            path: "/contact",
            name: "contact",
            components: {
                header: AppHeader,
                default: Contact,
                footer: AppFooter
            }
        },
        {
            path: "/apartment",
            name: "apartment",
            components: {
                header: AppHeader,
                default: Apartment,
                footer: AppFooter
            }
        },
        {
            path: "/covid",
            name: "covid",
            components: {
                header: AppHeader,
                default: CovidInfo,
                footer: AppFooter
            }
        },
        {
            path: "/gallery",
            name: "gallery",
            components: {
                header: AppHeader,
                default: Gallery,
                footer: AppFooter
            }
        },
        {
            path: "/morgue",
            name: "morgue",
            components: {
                header: AppHeader,
                default: Morgue,
                footer: AppFooter
            }
        },
        {
            path: "/faq",
            name: "faq",
            components: {
                header: AppHeader,
                default: FAQ,
                footer: AppFooter
            }
        },
        // {
        //     path: "/pandorum",
        //     name: "pandorum",
        //     components: {
        //         header: AppHeader,
        //         default: Pandorum,
        //         footer: AppFooter
        //     }
        // },
        // {
        //     path: "/quests",
        //     name: "quests",
        //     components: {
        //         header: AppHeader,
        //         default: Quests,
        //         footer: AppFooter
        //     }
        // },
        // {
        //     path: "/survey",
        //     name: "survey",
        //     components: {
        //         header: AppHeader,
        //         default: Survey,
        //         footer: AppFooter
        //     }
        // },
        //Blog posts
        {
            path: "/corona-update",
            name: "corona-update",
            components: {
                header: AppHeader,
                default: CoronaUpdate,
                footer: AppFooter
            }
        },
        {
            path: "/demolition-delayed",
            name: "demolition-delayed",
            components: {
                header: AppHeader,
                default: DemolitionDelayed,
                footer: AppFooter
            }
        },
        {
            path: "/otc-closing",
            name: "otc-closing",
            components: {
                header: AppHeader,
                default: OtcClosing,
                footer: AppFooter
            }
        },
        {
            path: "/otc-reopening",
            name: "otc-reopening",
            components: {
                header: AppHeader,
                default: OtcReopening,
                footer: AppFooter
            }
        },
        { path: '*', component: NotFound }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});
